// @flow
import React, { useEffect, useState } from 'react';
import {
  ScrollView,
  StyleSheet,
  useWindowDimensions,
  View,
} from 'react-native';
import { Content } from '../../design/components';
import { designConstants } from '../../design/styles';
import * as Animatable from 'react-native-animatable';
import Orientation from 'react-native-orientation-locker';
import { useNavigation, useRoute } from '@react-navigation/native';
import Button from '../../design/components/Button';
import strings from '../strings';
import useThemeContext from '../../design/styles/useThemeContext';

const SectionDrawer = (props) => {
  let firstChild = props.children[0];
  let i = 0;
  while (
    i < props.children.length &&
    (!firstChild || !firstChild.props || !firstChild.props.tag)
  ) {
    firstChild = props.children[i++];
  }
  const navigation = useNavigation();
  const route = useRoute();
  const { colors } = useThemeContext();

  const sectionParam = route?.params?.section;
  const [section, setSection] = useState(
    sectionParam || firstChild?.props?.tag,
  );
  const [content, setContent] = useState(
    sectionParam || firstChild?.props?.tag,
  );
  const { height, width } = useWindowDimensions();
  const isPortrait = height > width;
  const isTablet = designConstants.useIsTablet();

  useEffect(() => {
    if (sectionParam !== section && !props.disableSectionParams) {
      navigation?.setParams({ section });
    }
  }, [navigation, props.disableSectionParams, section, sectionParam]);

  const _onOrientationDidChange = (orientation) => {
    //    this.forceUpdate();
  };

  useEffect(() => {
    Orientation.addOrientationListener(_onOrientationDidChange);
    return () => {
      Orientation.removeOrientationListener(_onOrientationDidChange);
    };
  }, []);

  const selectSection = (section) => {
    setSection(section.props.tag);
    setTimeout(() => {
      setContent(section.props.tag);
    }, 500);
  };

  const { children, phoneMode, ...restProps } = props;

  const displayedSections = children.filter(
    (child) =>
      child &&
      child.props &&
      !child.props.directRender &&
      child.props.children &&
      typeof child.props.children !== 'string',
  );

  const selectAllItems = (section) => {
    if (props.onSelectAllItems && section.props?.tag) {
      props.onSelectAllItems(section.props.tag);
    }
  };

  if (!isTablet || phoneMode) {
    const ContentView = props.plainView ? View : Content;

    return (
      <ContentView
        contentContainerStyle={props.style}
        scrollEnabled={props.scrollEnabled}
        keyboardShouldPersistTaps="always"
        scrollRef={props.scrollRef}
      >
        {props.children}
      </ContentView>
    );
  }

  const ContentView =
    designConstants.isWeb && !props.plainView ? Content : View;
  return (
    <ContentView style={{ flex: 1 }}>
      <View {...restProps} style={styles.container}>
        <View style={{ flex: 1 }}>
          <ScrollView>
            <View
              style={[
                {
                  flexDirection: 'column',
                  backgroundColor: colors.defaultBackground,
                  marginTop: 20,
                  marginLeft: 20,
                },
                isTablet && {
                  borderRadius: 8,
                },
                props.style,
              ]}
            >
              {children.map((child) => {
                if (child && child.props && child.props.directRender) {
                  return <View>{child}</View>;
                }
                if (!child || !child.props || !child.props.children) {
                  return null;
                }
                return (
                  <View>
                    {React.cloneElement(child, {
                      childrenProps:
                        typeof child.props.children !== 'string' &&
                        child.props.children.props,
                      children:
                        typeof child.props.children === 'string'
                          ? child.props.children
                          : null,
                      selected: section === child.props.tag,
                      onPress: () => selectSection(child),
                    })}
                  </View>
                );
              })}
            </View>
          </ScrollView>
        </View>
        <View style={{ flex: isPortrait ? 1 : 2 }}>
          <ScrollView>
            <View
              grow
              style={props.style}
              scrollEnabled={props.scrollEnabled}
              keyboardShouldPersistTaps="always"
              scrollRef={props.scrollRef}
            >
              <ScrollView
                style={{
                  flex: 1,
                  flexGrow: 1,
                  paddingVertical: 20,
                  paddingLeft: 20,
                  paddingRight: designConstants.isWeb ? 0 : 20,
                }}
              >
                {displayedSections.map((child, key) => {
                  const sel =
                    content === child.props.tag && section === content;
                  const fadeOut =
                    content === child.props.tag && section !== content;
                  if (!sel) {
                    return null;
                  }
                  const hideSelectAllButton =
                    child.props?.hideSelectAllButton || false;
                  const nextSection = displayedSections[key + 1];
                  return (
                    <Animatable.View
                      duration={300}
                      animation={fadeOut ? 'fadeOut' : sel ? 'fadeIn' : null}
                      style={{
                        position: sel || fadeOut ? 'relative' : 'absolute',
                        flexGrow: 1,
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: colors.defaultBackground,
                          borderRadius: 8,
                        }}
                      >
                        {!hideSelectAllButton && !!props.onSelectAllItems && (
                          <Button
                            outlined
                            style={{
                              alignSelf: 'flex-end',
                              marginTop: designConstants.paddings.edgePadding,
                              marginRight: designConstants.paddings.edgePadding,
                            }}
                            text={strings.section_drawer_select_all_button}
                            onPress={() => selectAllItems(child)}
                          />
                        )}
                        <ScrollView
                          style={{
                            paddingVertical:
                              sel || fadeOut
                                ? designConstants.paddings.edgePadding
                                : 0,
                            opacity: sel || fadeOut ? 1 : 0,
                            height: sel || fadeOut ? undefined : 0,
                            width: sel || fadeOut ? undefined : 0,
                          }}
                        >
                          {React.cloneElement(child.props.children)}
                        </ScrollView>
                      </View>
                      {!props.hideNextSectionButton && nextSection && (
                        <Button
                          style={{
                            alignSelf: 'flex-end',
                            marginTop: designConstants.paddings.edgePadding,
                            marginBottom: 36,
                          }}
                          text={strings.section_drawer_continue_to_next_section}
                          onPress={() => selectSection(nextSection)}
                        />
                      )}
                    </Animatable.View>
                  );
                })}
              </ScrollView>
            </View>
          </ScrollView>
        </View>
      </View>
    </ContentView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'stretch',
  },
  rowContent: {
    flex: 1,
    flexDirection: 'row',
  },
  row: {
    flexDirection: 'row',
    margin: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  biggerText: {
    fontSize: 17,
    alignSelf: 'center',
  },
  button: {
    margin: 5,
  },
});

export { SectionDrawer };
